import HubertSwitch from 'components/HubertUI/HubertSwitch';
import HubertLabel from 'components/HubertUI/HubertLabel';
import { useQuestionEditorContext } from '../context/create-question.context';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionSendDataToLooker, selectQuestionMode } from 'rtk/questionEditorSelector';
import { updateSendDataToLooker } from 'rtk/Question.Editor.Slice';
import { ECreateQuestionMode } from '../context/create-question.context';
import { useTranslation } from 'react-i18next';

const SendDataToLookerSwitch = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const send_data_to_looker = useAppSelector((state) => selectQuestionSendDataToLooker(state, questionId));
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));

  const disabled = mode === ECreateQuestionMode.InTemplateEdit;

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-3">
        <h3 className="text-sm font-semibold">{t('sendDataToLooker.heading')}</h3>
        <div className="h-px flex-1 bg-gray-200" />
      </div>

      <div className="flex flex-col gap-2">
        <div className="flex flex-row items-center justify-between gap-4 py-1">
          <HubertLabel htmlFor="create-question-send-data-to-looker" className="cursor-pointer text-sm">
            {t('sendDataToLooker.label')}
          </HubertLabel>
          <HubertSwitch
            id="create-question-send-data-to-looker"
            disabled={disabled}
            checked={send_data_to_looker}
            onCheckedChange={(checked: boolean) => {
              dispatch(updateSendDataToLooker({ questionId, value: checked }));
            }}
          />
        </div>

        <div className="rounded-md border border-amber-200 bg-amber-50 p-2.5">
          <p className="text-xs leading-5 text-amber-800">{t('sendDataToLooker.warning')}</p>
        </div>
      </div>
    </div>
  );
};

export default SendDataToLookerSwitch;
